export const RECENT_TRANSACTIONS_REQUEST = 'AIRTIMEDATA/RECENT-TRANSACTIONS/REQUESTED';
export const RECENT_TRANSACTIONS_RECEIVED = 'AIRTIMEDATA/RECENT-TRANSACTIONS/RECEIVED';
export const ORDER_DETAIL_PROVIDERS_REQUEST = 'AIRTIMEDATA/ORDER-DETAIL/PROVIDERS/REQUESTED';
export const ORDER_DETAIL_PROVIDERS_RECEIVED = 'AIRTIMEDATA/ORDER-DETAIL/PROVIDERS/RECEIVED';
export const PLACE_ORDER_REQUEST = 'AIRTIMEDATA/PLACE-ORDER/REQUESTED';
export const PLACE_ORDER_RECEIVED = 'AIRTIMEDATA/PLACE-ORDER/COMPLETE_RECEIVED';
export const CREATE_ORDER_EDIT = 'AIRTIMEDATA/CREATE_ORDER_EDIT';
